import React from 'react';
interface LeadSource {
  platform: string;
  type: 'paid' | 'organic';
  count: string;
  icon: React.ReactNode;
}
const GoogleIcon = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" data-id="element-1100">
    <path d="M22.5 12.5c0-1.58-.875-2.95-2.148-3.6.154-.435.238-.905.238-1.4 0-2.21-1.71-3.998-3.818-3.998-.47 0-.92.084-1.336.25C14.818 2.415 13.51 1.5 12 1.5s-2.816.917-3.437 2.25c-.415-.165-.866-.25-1.336-.25-2.11 0-3.818 1.79-3.818 4 0 .494.083.964.237 1.4-1.272.65-2.147 2.018-2.147 3.6 0 1.495.782 2.798 1.942 3.486-.02.17-.032.34-.032.514 0 2.21 1.708 4 3.818 4 .47 0 .92-.086 1.335-.25.62 1.334 1.926 2.25 3.437 2.25 1.512 0 2.818-.916 3.437-2.25.415.163.865.248 1.336.248 2.11 0 3.818-1.79 3.818-4 0-.174-.012-.344-.033-.513 1.158-.687 1.943-1.99 1.943-3.484z" fill="#4285F4" data-id="element-1101" />
  </svg>;
const FacebookIcon = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" data-id="element-1102">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" fill="#1877F2" data-id="element-1103" />
  </svg>;
const AggregatorIcon = ({
  color
}: {
  color: string;
}) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" data-id="element-1104">
    <rect x="3" y="3" width="18" height="18" rx="4" fill={color} data-id="element-1105" />
    <path d="M8 12h8M12 8v8" stroke="white" strokeWidth="2" strokeLinecap="round" data-id="element-1106" />
  </svg>;
const LEAD_SOURCES: LeadSource[] = [{
  platform: 'Google Leads',
  type: 'paid',
  count: '31.69K',
  icon: <GoogleIcon data-id="element-1107" />
}, {
  platform: 'Facebook Leads',
  type: 'paid',
  count: '17.93K',
  icon: <FacebookIcon data-id="element-1108" />
}, {
  platform: 'CD',
  type: 'paid',
  count: '12.45K',
  icon: <AggregatorIcon color="#8B5CF6" data-id="element-1109" />
}, {
  platform: 'CW',
  type: 'paid',
  count: '9.82K',
  icon: <AggregatorIcon color="#EC4899" data-id="element-1110" />
}, {
  platform: '91W',
  type: 'paid',
  count: '7.21K',
  icon: <AggregatorIcon color="#14B8A6" data-id="element-1111" />
}, {
  platform: 'Google Leads',
  type: 'organic',
  count: '47.32K',
  icon: <GoogleIcon data-id="element-1112" />
}];
export function LeadSourceBreakup() {
  return <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm" data-id="element-1113">
      <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-1114">
        Lead Source Breakup
      </h3>

      <div className="space-y-6" data-id="element-1115">
        {/* Paid Leads */}
        <div data-id="element-1116">
          <div className="flex items-center mb-4" data-id="element-1117">
            <div className="w-1 h-6 bg-gray-900 rounded-full mr-3" data-id="element-1118"></div>
            <h4 className="text-sm font-bold text-gray-900 uppercase tracking-wide" data-id="element-1119">
              PAID LEADS
            </h4>
          </div>
          <div className="space-y-4 pl-4" data-id="element-1120">
            {LEAD_SOURCES.filter(s => s.type === 'paid').map((source, i) => <div key={i} className="flex items-center justify-between" data-id="element-1121">
                <div className="flex items-center space-x-3" data-id="element-1122">
                  <div className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center" data-id="element-1123">
                    {source.icon}
                  </div>
                  <span className="text-sm text-gray-700" data-id="element-1124">
                    {source.platform}
                  </span>
                </div>
                <span className="text-xl font-bold text-orange-500" data-id="element-1125">
                  {source.count}
                </span>
              </div>)}
          </div>
        </div>

        {/* Organic Leads */}
        <div data-id="element-1126">
          <div className="flex items-center mb-4" data-id="element-1127">
            <div className="w-1 h-6 bg-blue-600 rounded-full mr-3" data-id="element-1128"></div>
            <h4 className="text-sm font-bold text-gray-900 uppercase tracking-wide" data-id="element-1129">
              ORGANIC LEADS
            </h4>
          </div>
          <div className="space-y-4 pl-4" data-id="element-1130">
            {LEAD_SOURCES.filter(s => s.type === 'organic').map((source, i) => <div key={i} className="flex items-center justify-between" data-id="element-1131">
                  <div className="flex items-center space-x-3" data-id="element-1132">
                    <div className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center" data-id="element-1133">
                      {source.icon}
                    </div>
                    <span className="text-sm text-gray-700" data-id="element-1134">
                      {source.platform}
                    </span>
                  </div>
                  <span className="text-xl font-bold text-orange-500" data-id="element-1135">
                    {source.count}
                  </span>
                </div>)}
          </div>
        </div>
      </div>
    </div>;
}